import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment, renderList as _renderList, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lot-main-seller-block auction-status-block box-shadow"
}
const _hoisted_2 = { class: "auction-status-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "link-dashed" }
const _hoisted_5 = { class: "link-dashed" }
const _hoisted_6 = {
  key: 0,
  class: "lot-info-wrapper"
}
const _hoisted_7 = { class: "lot-number" }
const _hoisted_8 = {
  key: 0,
  class: "meta"
}
const _hoisted_9 = {
  key: 1,
  class: "separator"
}
const _hoisted_10 = {
  key: 2,
  class: "meta"
}
const _hoisted_11 = {
  key: 3,
  class: "separator"
}
const _hoisted_12 = {
  key: 4,
  class: "meta meta-vendor"
}
const _hoisted_13 = { class: "lot-image" }
const _hoisted_14 = { class: "mobile-vendor-name-wrapper" }
const _hoisted_15 = { class: "vendor-name" }
const _hoisted_16 = {
  key: 0,
  class: "admin-note"
}
const _hoisted_17 = { class: "mobile-bid-info-wrapper" }
const _hoisted_18 = { id: "history-mobile-wrapper" }
const _hoisted_19 = {
  key: 0,
  class: "admin-note mobile-block"
}
const _hoisted_20 = { class: "current-lot-info-block" }
const _hoisted_21 = { class: "current-bid-info" }
const _hoisted_22 = {
  key: 0,
  class: "bidder-name"
}
const _hoisted_23 = { class: "bidder-bid" }
const _hoisted_24 = {
  key: 0,
  class: "meta"
}
const _hoisted_25 = {
  key: 1,
  class: "separator"
}
const _hoisted_26 = {
  key: 2,
  class: "meta"
}
const _hoisted_27 = { class: "lot-description-block" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "mobile-actions-wrapper" }
const _hoisted_31 = { class: "mobile-actions-block" }
const _hoisted_32 = {
  key: 0,
  class: "current-bid"
}
const _hoisted_33 = {
  key: 0,
  class: "lot-description-block mobile-lot-description-block"
}
const _hoisted_34 = { class: "title" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "event-messages" }
const _hoisted_37 = { class: "current-bid-anim" }
const _hoisted_38 = {
  key: 0,
  class: "right-block__increment"
}
const _hoisted_39 = {
  key: 1,
  class: "right-block__max-bid"
}
const _hoisted_40 = {
  key: 2,
  class: "right-block-action-buttons"
}
const _hoisted_41 = {
  key: 1,
  class: "change-price-form"
}
const _hoisted_42 = { class: "right-block__bid no-bids" }
const _hoisted_43 = { class: "bidders-history" }
const _hoisted_44 = { class: "no-bids-label" }
const _hoisted_45 = {
  key: 2,
  class: "time-to-resume-wrapper"
}
const _hoisted_46 = { class: "resume-label" }
const _hoisted_47 = {
  key: 2,
  class: "auction-status-block"
}
const _hoisted_48 = { class: "auction-status-wrapper" }

import { computed, nextTick, onBeforeUnmount, ref, watch } from "vue";
  import { History } from "@/components/action-block/tabs";
  import Api from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { formatCatalogValueRange, humanizedCatalog, humanizedCondition } from "@/utils/lot";
  import { trans } from "@/utils/trans";
  import { format_currency } from "@/utils/currencies";
  import { AuctionStatuses, LotStatuses } from "@/enum";
  import LotGallery from "@/components/_partials/LotGallery.vue";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import ActionButtons from "@/components/seller/ActionButtons.vue";
  import TimeLine from "@/components/_partials/TimeLine.vue";
  import CustomInput from "@/components/_partials/widget/CustomInput.vue";
  import { isObject } from "lodash";
  import { useToast } from "primevue/usetoast";
  import FastBidVariantsToggle from "@/components/_partials/FastBidVariantsToggle.vue";
  import { isScreenL } from "@/utils/media-size";
  import TimerLiveAuctionBegin from "@/components/_partials/TimerLiveAuctionBegin.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotMainSeller',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const toast = useToast();
  const auctionStatus = computed(() => auctionStore.auction.status);
  const lots = computed(() => auctionStore.lots);

  const bidIncrementRules = computed(() => auctionStore.auction.bid_increment_rules);
  const auction = computed(() => auctionStore.auction);
  const liveLot = computed(() => lots.value.find((item) => item.status === LotStatuses.LIVE));
  const endedLots = computed(() => lots.value.filter((item) => item.status === LotStatuses.ENDED));
  const activeLot = computed(() =>
    auctionStore.activeLot?.id
      ? auctionStore.activeLot
      : auctionStore.fakeActiveLot?.id
        ? auctionStore.fakeActiveLot
        : liveLot.value
  );
  const currentBid = computed(() => (activeLot.value ? activeLot.value?.current_bid : 0));
  const catalog = computed(() => (activeLot.value ? humanizedCatalog(activeLot.value, true) : null));
  const catalogValue = computed(() => (activeLot.value ? formatCatalogValueRange(activeLot.value, true) : null));
  const vendorName = computed(() => (activeLot.value ? activeLot.value?.vendor_name : null));
  const condition = computed(() => (activeLot.value ? humanizedCondition(activeLot.value, true) : null));
  const isSingleMeta = computed(() => {
    const result = [];
    catalog.value && result.push(catalog);
    catalogValue.value && result.push(catalogValue);
    condition.value && result.push(condition);
    return result.length === 1;
  });
  const formattedIncrement = computed(() => {
    const rule = bidIncrementRules.value
      .slice()
      .reverse()
      .find((rule) => currentBid.value && currentBid.value >= rule.min_current_bid);

    return format_currency(rule ? rule.bid_step : 1);
  });
  const formattedCatalog = (catalog: string) => {
    return catalog.length > 5 ? catalog.slice(0, 5) + "..." : catalog;
  };
  const isShowActionButtons = ref(false);
  const isShowChangePriceForm = ref(false);
  const changePriceAmount = ref<number>(null);

  const liveBreakEnd = computed(() => auction.value.live_break_end);
  const showMobileBidControls = computed(
    () => isScreenL.value && auctionStatus.value === AuctionStatuses.LIVE && lots.value.length > endedLots.value.length && !!liveLot.value?.id
  );
  const mobileActionButtonsWrapper = ref<HTMLDivElement | null>(null);
  const mobileActionButtonsReady = ref(false);
  let mobileActionButtonsObserver: MutationObserver | null = null;
  const leadersListWithoutBookBid = computed(() => {
    if (!activeLot.value?.leaders_list?.length) {
      return [];
    }

    const firstBidder = activeLot.value?.leaders_list[0];

    return activeLot.value?.leaders_list?.filter((item) => {
      return !item.is_book_bid && item.user_id !== firstBidder.user_id;
    });
  });

  const retractBid = () => {
    if (activeLot.value?.id) {
      Api.post("/live/lots/" + activeLot.value.id + "/retract-bid").catch((error) => {
        console.log(error);
      });
    }
  };

  const toggleShowActionButtons = () => {
    isShowActionButtons.value = !isShowActionButtons.value;
  };

  const toggleShowChangePriceForm = () => {
    isShowChangePriceForm.value = !isShowChangePriceForm.value;
  };

  const syncMobileActionButtonsReady = () => {
    mobileActionButtonsReady.value = !!mobileActionButtonsWrapper.value?.querySelector(".can-toggle-on-mob");
  };

  watch(
    showMobileBidControls,
    async (isVisible) => {
      mobileActionButtonsObserver?.disconnect();
      mobileActionButtonsObserver = null;

      if (!isVisible) {
        mobileActionButtonsReady.value = false;
        return;
      }

      await nextTick();
      syncMobileActionButtonsReady();

      if (mobileActionButtonsWrapper.value) {
        mobileActionButtonsObserver = new MutationObserver(() => {
          syncMobileActionButtonsReady();
        });
        mobileActionButtonsObserver.observe(mobileActionButtonsWrapper.value, { childList: true, subtree: true });
      }
    },
    { immediate: true }
  );

  onBeforeUnmount(() => {
    mobileActionButtonsObserver?.disconnect();
  });

  const changePrice = () => {
    Api.post("/api/lots/" + activeLot.value.id + "/update-current-bid", {
      amount: changePriceAmount.value
    })
      .then((response) => {
        if (response.data.success) {
          toast.add({
            severity: "success",
            summary: trans("live.toast.success"),
            detail: trans("live.toast.lot.price_changed"),
            life: 6000
          });
          changePriceAmount.value = null;
          isShowChangePriceForm.value = false;
        }
      })
      .catch((error) => {
        if (isObject(error.response.data?.errors)) {
          const errors = [];
          Object.values(error.response.data.errors).forEach((itemErrors) => {
            errors.push(...itemErrors);
          });

          errors.forEach((error) => {
            toast.add({
              severity: "error",
              summary: trans("live.toast.error"),
              detail: error || trans("live.toast.unknown_error"),
              life: 6000
            });
          });
        }
      });
  };

  const bidderStatus = (bidInfo) => {
    const userData = auctionStore.userData[bidInfo?.user_id];
    return userData && userData.status === "active";
  };

return (_ctx: any,_cache: any) => {
  return (auctionStatus.value === _unref(AuctionStatuses).ENDED)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(trans)("live.auction_states.closed.title")), 1),
          _createElementVNode("button", _hoisted_4, _toDisplayString(_unref(trans)("live.auction_states.closed.download_results")), 1),
          _createElementVNode("button", _hoisted_5, _toDisplayString(_unref(trans)("live.auction_states.closed.download_log")), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['lot-main-seller-block box-shadow', `status-${auctionStatus.value.toLowerCase()}`])
      }, [
        (activeLot.value?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(trans)("live.common.main_info.lot_number", { number: activeLot.value.lot_number })), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["lot-meta", { single: isSingleMeta.value }])
              }, [
                (condition.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(condition.value), 1))
                  : _createCommentVNode("", true),
                ((catalogValue.value || vendorName.value) && condition.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                  : _createCommentVNode("", true),
                (catalogValue.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(catalogValue.value), 1))
                  : _createCommentVNode("", true),
                (vendorName.value && catalogValue.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                  : _createCommentVNode("", true),
                (vendorName.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(vendorName.value), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(vendorName.value), 1)
                ]),
                _createVNode(LotGallery, { class: "seller-gallery" }),
                (activeLot.value?.admin_notes?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(activeLot.value?.admin_notes), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (_unref(isScreenL))
                      ? (_openBlock(), _createBlock(_unref(History), {
                          key: 0,
                          "disable-mobile-teleport": true
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (activeLot.value?.admin_notes?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(activeLot.value?.admin_notes), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (activeLot.value.leaders_list?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(activeLot.value.leaders_list[0].user_name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(activeLot.value.leaders_list?.length
                    ? _unref(format_currency)(activeLot.value.leaders_list[0].amount)
                    : _unref(trans)("live.common.leaders_list.no_bids")), 1)
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "separator-line" }, null, -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["lot-meta", { single: isSingleMeta.value }])
                    }, [
                      (condition.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(condition.value), 1))
                        : _createCommentVNode("", true),
                      ((catalogValue.value || catalog.value) && condition.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                        : _createCommentVNode("", true),
                      (catalogValue.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(catalogValue.value), 1))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(CustomScrollbar, { class: "custom-scrollbar mini lot-description-scrollbar controller-scrollbar" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(activeLot.value.title), 1),
                    _createElementVNode("div", {
                      class: "description",
                      innerHTML: activeLot.value.description
                    }, null, 8, _hoisted_29)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (auctionStatus.value !== _unref(AuctionStatuses).ACTIVE)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (activeLot.value?.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(format_currency)(currentBid.value)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    ref_key: "mobileActionButtonsWrapper",
                    ref: mobileActionButtonsWrapper,
                    class: "actions-buttons-wrapper"
                  }, null, 512),
                  (showMobileBidControls.value && mobileActionButtonsReady.value)
                    ? (_openBlock(), _createBlock(FastBidVariantsToggle, {
                        key: 1,
                        target: ".actions-buttons-wrapper .can-toggle-on-mob"
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              (activeLot.value?.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createVNode(CustomScrollbar, { class: "custom-scrollbar mini lot-description-scrollbar controller-scrollbar" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(activeLot.value.title), 1),
                        _createElementVNode("div", {
                          class: "description",
                          innerHTML: activeLot.value.description
                        }, null, 8, _hoisted_35)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_36, [
                (!_unref(isScreenL))
                  ? (_openBlock(), _createBlock(_unref(History), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              (activeLot.value?.id)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(['right-block', { 'small-margin': _unref(auctionStore).liveSettings?.show_bid_increments }])
                  }, [
                    (activeLot.value?.leaders_list?.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["right-block__bid winner", { toggled: isShowActionButtons.value }]),
                            onClick: toggleShowActionButtons
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_Transition, { name: "current-bid" }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("div", {
                                    class: "current-bid",
                                    key: currentBid.value ?? 0
                                  }, _toDisplayString(_unref(format_currency)(currentBid.value)), 1))
                                ]),
                                _: 1
                              })
                            ])
                          ], 2),
                          (!isShowChangePriceForm.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_unref(auctionStore).liveSettings?.show_bid_increments)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(trans)("live.common.leaders_list.increment", { amount: formattedIncrement.value })), 1))
                                  : _createCommentVNode("", true),
                                (activeLot.value.leaders_list[0] && activeLot.value.leaders_list[0].amount > currentBid.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(format_currency)(activeLot.value.leaders_list[0].amount)), 1))
                                  : _createCommentVNode("", true),
                                (isShowActionButtons.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _createElementVNode("span", {
                                        onClick: toggleShowChangePriceForm,
                                        class: "action-button stage-b-item"
                                      }, _toDisplayString(_unref(trans)("live.common.leaders_list.change_price")), 1),
                                      _createElementVNode("span", {
                                        onClick: retractBid,
                                        class: "action-button"
                                      }, _toDisplayString(_unref(trans)("live.common.leaders_list.retract_bid")), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createVNode(CustomInput, {
                                  type: "number",
                                  "input-class": "input",
                                  modelValue: changePriceAmount.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((changePriceAmount).value = $event)),
                                  placeholder: _unref(trans)('live.common.leaders_list.change_price_placeholder')
                                }, null, 8, ["modelValue", "placeholder"]),
                                _createElementVNode("button", {
                                  class: "btn btn-blue btn-click-effect",
                                  onClick: changePrice
                                }, _toDisplayString(_unref(trans)("live.common.buttons.confirm")), 1),
                                _createElementVNode("button", {
                                  class: "btn btn-blue-outline btn-click-effect",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowChangePriceForm.value = false))
                                }, _toDisplayString(_unref(trans)("live.common.buttons.cancel")), 1)
                              ])),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "separator" }, null, -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(['bidder-current-name', { 'margin-bottom-0': isShowActionButtons.value }])
                          }, _toDisplayString(activeLot.value.leaders_list[0].user_name), 3),
                          (leadersListWithoutBookBid.value?.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(['bidders-history', { 'hidden-action-buttons': isShowActionButtons.value }])
                              }, [
                                (!isShowActionButtons.value)
                                  ? (_openBlock(), _createBlock(CustomScrollbar, {
                                      key: 0,
                                      class: "custom-scrollbar controller-scrollbar bidders-history-scrollbar"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leadersListWithoutBookBid.value.slice(0, 4), (bid, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(['bidder-name', { active: bidderStatus(bid) }]),
                                            key: index
                                          }, _toDisplayString(bid.user_name), 3))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(format_currency)(currentBid.value)), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "separator" }, null, -1)),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(trans)("live.common.leaders_list.no_bids")), 1)
                          ])
                        ], 64)),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator" }, null, -1)),
                    (liveBreakEnd.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(trans)("live.common.leaders_list.break_enabled")), 1)
                        ]))
                      : (_openBlock(), _createBlock(_Teleport, {
                          key: 3,
                          disabled: !_unref(isScreenL),
                          to: ".mobile-actions-wrapper .mobile-actions-block",
                          defer: ""
                        }, [
                          _createVNode(TimeLine)
                        ], 8, ["disabled"]))
                  ], 2))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_Teleport, {
                disabled: !_unref(isScreenL),
                to: ".mobile-actions-wrapper .mobile-actions-block .actions-buttons-wrapper",
                defer: ""
              }, [
                _createVNode(ActionButtons)
              ], 8, ["disabled"]))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(TimerLiveAuctionBegin)
              ])
            ]))
      ], 2))
}
}

})